import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_VANTIVE_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_VANTIVE,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_VANTIVE_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_VANTIVE_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_VANTIVE_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  VANTIVE_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  VANTIVE_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_VANTIVE,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE,
  OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  VANTIVE_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_VANTIVE,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Portal de retorno do produto";
translations[LANDING_BRIEF] = "O Portal on-line de feedback de Produto Vantive destina-se ao envio de informações confidenciais e feedback sobre os produtos da Vantive.";
translations[LANDING_LANGUAGE_SELECTOR] = "Selecione a preferência de idioma";
translations[LANDING_COUNTRY_SELECTOR] = "Selecione o país do evento";
translations[LANDING_TERMS] = "Li e concordo com os Termos de Uso e a Declaração de Privacidade do Portal de retorno do Produto da Vantive.";
translations[LANDING_TERMS_ERROR] = "Você deve ler e concordar com o conteúdo dos Termos de Uso, da Declaração de Privacidade e do Portal de retorno do Produto da Vantive Termo de Uso e Declaração de Privacidade do Portal de retorno do Produto Vantive.";
translations[LANDING_CAPTCHA_ERROR] = "Verifique se você não é um robô.";
translations[APP_DESCRIPTION] = "O Sistema de Portal de Feedback de Produto destina-se ao envio de informações sobre produtos. Se você encontrou algum problema com um produto Vantive, recomendamos que você compartilhe os detalhes desse evento. Todo feedback é essencial para cumprirmos nossos objetivos comuns de melhoria contínua e satisfação do produto.";
translations[LANDING_TERMS_I_HAVE_READ] = "Li o Aviso de Privacidade vinculado ao Portal de Feedback de Produtos da Vantive e entendo que a Vantive  Healthcare Corporation (“Vantive”) está solicitando meu consentimento para usar, divulgar e processar meus dados pessoais para os fins e conforme descrito na Política de Privacidade. Eu, por meio deste, concordo em:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "O uso, divulgação, armazenamento e processamento de meus dados pessoais (incluindo quaisquer dados confidenciais, como dados relacionados à saúde, que eu decida fornecer) para os fins descritos no Aviso de Privacidade.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "A transferência de meus dados pessoais (incluindo dados confidenciais, como dados relacionados à saúde, que eu escolho fornecer) para fora do meu país e para outro país que possa ter leis de proteção de dados menos rígidas ou nenhuma lei de proteção de dados.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Entendo que esse consentimento é voluntário e que posso mudar de ideia a qualquer momento e revogar meu consentimento entrando em contato com a Vantive usando os detalhes de contato fornecidos no Aviso de Privacidade. Entendo que retirar meu consentimento não afetará a legalidade do processamento antes de sua retirada.";
translations[MENU_FEEDBACK_FORM] = "Iniciar o retorno do produto ";
translations[MENU_FEEDBACK_STATUS] = "Verifique o status do retorno do produto";
translations[MENU_FORM_INTAKE] = "Reporte/Informações de contato";
translations[MENU_FORM_EVENT_DETAILS] = "Detalhes do evento";
translations[MENU_FORM_PRODUCT_INFO] = "Informações sobre o produto";
translations[SYSTEM_FEEDBACK_FORM] = "Iniciar formulário de retorno do produto";
translations[SYSTEM_FEEDBACK_STATUS] = "Verifique o status do retorno do produto";
translations[SUBMIT_FEEDBACK] = "Clique aqui para enviar retorno.";
translations[CHECK_SUBMITTED_FEEDBACK] = "Clique aqui para verificar o status do retorno enviado anteriormente.";
translations[BTN_LAUNCH_FORM] = "Formulário de lançamento";
translations[BTN_CHECK_STATUS] = "Verificar o status";
translations[FORM_TITLE] = "Formuário de retorno do produto";
translations[FORM_SUB_TITLE] = "Se houver vários pacientes envolvidos, preencha um formulário para cada paciente.";
translations[FORM_MANDATORY_FIELDS] = "Todos os campos com * são obrigatórios";
translations[BUTTON_PREV] = "Anterior";
translations[BUTTON_NEXT] = "Próximo";
translations[BUTTON_SUBMIT] = "Enviar";
translations[SELECT_RESPONSE] = "Selecionar resposta";
translations[FUNCTION_ROLE] = "Função/Cargo";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Número da conta do cliente";
translations[ENTER_CUSTOMER_ACCOUNT] = "Inserir conta de cliente";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Qual é o número da conta do cliente envolvido no evento reportado?";
translations[EVENT_REPORTED] = "Este evento foi relatado anteriormente (à Vantive ou a qualquer outra entidade)?";
translations[REFERENCE_NUMBER] = "Número de referência associado a este evento";
translations[ENTER_REFERENCE] = "Inserir referência";
translations[WHO_REPORTED_TO] = "A quem isso foi relatado?";
translations[WHO_WAS_NOTIFIED] = "Fornecer o nome de quem foi notificado?";
translations[ENTER_NAME] = "Inserir o nome";
translations[YOUR_NAME] = "Seu nome";
translations[OCCUPATION] = "Ocupação";
translations[PHONE_NUMBER] = "Número de telefone";
translations[ENTER_PHONE_NUMBER] = "Inserir o número de telefone";
translations[ENTER_EMAIL] = "Inserir o e-mail";
translations[EMAIL_ADDRESS] = "Endereço de e-mail";
translations[ENTER_ADDRESS] = "Inserir o endereço de e-mail";
translations[ENTER_NA_IF_UNKNOWN] = "Digite' NA' se desconhecido";
translations[FACILITY_HOSPITAL] = "Nome da empresa/hospital ou distribuidor (se aplicável)";
translations[ENTER_FACILITY] = "Inserir a empresa";
translations[ADDRESS_1] = "Endereço 1";
translations[ADDRESS_2] = "Endereço 2";
translations[CITY] = "Cidade";
translations[STATE] = "Estado";
translations[POSTAL_CODE] = "Código postal (CEP)";
translations[COUNTRY] = "País";
translations[END_USER_CUSTOMER] = "Esse problema foi descoberto por um usuário/cliente final?";
translations[ADDITIONAL_CONTACT_PERSON] = "Contato adicional ";
translations[ADDITIONAL_PHONE] = "Número de telefone de contato adicional";
translations[ADDITIONAL_EMAIL] = "E-mail de contato adicional";
translations[ANOTHER_FACILITY_ADDRESS] = "Adicione outra instalação/endereço";
translations[ANOTHER_FACILITY_HOSPITAL] = "Nome de outra instalação/hospital ou distribuidor (se aplicável)";
translations[ANOTHER_ENTER_FACILITY] = "Inserir a empresa";
translations[ANOTHER_ADDRESS_1] = "Endereço 1";
translations[ANOTHER_ADDRESS_2] = "Endereço 2";
translations[ANOTHER_CITY] = "Cidade";
translations[ANOTHER_STATE] = "Estado";
translations[ANOTHER_POSTAL_CODE] = "Código postal (CEP)";
translations[ANOTHER_COUNTRY] = "País";
translations[LOT_SERIAL_NUMBER] = "Número do lote/Número de série";
translations[ENTER_LOT_SERIAL_NUMBER] = "Inserir número do lote/número de série";
translations[HELP_LOT_SERIAL_NUMBER] = "Selecione Desconhecido se você não souber o número do Lote/Série, ou se você perguntou ao repórter e ele não sabia.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Código do produto";
translations[PRODUCT_CODE] = "Código do produto";
translations[ENTER_PRODUCT_CODE] = "Inserir o código do produto";
translations[HELP_PRODUCT_CODE] = "Selecione Desconhecido se você não souber o Código do Produto ou se perguntou ao repórter e ele não sabia.";
translations[NDC] = "Número do Código Nacional de Medicamentos ";
translations[ENTER_NDC] = "Digite o NDC";
translations[UDI] = "Identificador de dispositivo exclusivo";
translations[ENTER_UDI] = "Digite o UDI";
translations[PRODUCT_NAME] = "Nome do produto";
translations[ENTER_PRODUCT_NAME] = "Inserir o nome do produto";
translations[HELP_PRODUCT_NAME] = "Forneça o nome ou a descrição do produto";
translations[BEST_DESCRIBES] = "Faça uma seleção que melhor descreva o problema relatado";
translations[QUANTITY_TO_SELECT] = "Quantidade a ser selecionada";
translations[ENTER_QUANTITY] = "Inserir quantidade";
translations[HELP_QUANTITY] = "Número de produtos com o problema relatado";
translations[UNIT] = "Unidade";
translations[AVAILABLE_TO_RETURNED] = "O produto no qual o problema foi relatado está disponível para ser devolvido à Vantive para avaliação?";
translations[PHOTOGRAPH_AVAILABLE] = "Uma fotografia ou vídeo do produto está disponível?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Certifique-se de que o problema relatado esteja visível na foto ou no vídeo.";
translations[UPLOAD_IMAGES] = "Fazer upload de imagens";
translations[REPORTER_NAME] = "Nome do notificador";
translations[REPORTER_FACILITY] = "Empresa do notificador";
translations[REPORTER_OCCUPATION] = "Ocupação do notificador";
translations[ENTER_NUMBER] = "Digite o número";
translations[REPORTER_PHONE_NUMBER] = "Número de telefone do notificador";
translations[REPORTER_EMAIL_ADDRESS] = "Endereço de e-mail do notificador";
translations[EMPLOYEE_NAME] = "Nome do funcionário";
translations[EMPLOYEE_PHONE_NUMBER] = "Número de telefone do funcionário";
translations[EMPLOYEE_EMAIL_ADDRESS] = "Endereço de e-mail do funcionário";
translations[RETURNING_FOR_INVESTIGATION] = "Quantas amostras (em unidades) com o problema relatado você está retornando para investigação?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Essas amostras devem ser do produto com o problema relatado.";
translations[UNUSED_VANTIVE_PRODUCT] = "Existe um produto Vantive não utilizado do mesmo lote disponível para ser devolvido à Vantive para avaliação?";
translations[YOU_INDICATED_SAMPLES] = "Você indicou que as amostras estavam disponíveis para avaliação, você é capaz de trazê-las para seu profissional de saúde?";
translations[SAMPLE_RETURN_KIT] = "Você indicou que as amostras estavam disponíveis para avaliação,  por favor confirme o endereço fornecido para enviar o kit de devolução da amostra:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Uma caixa com uma etiqueta pré-paga será enviada para este endereço para devolver a amostra";
translations[SAME_AS_MY_ADDRESS] = "Igual ao meu endereço";
translations[OTHER_CONTACT_NAME] = "Nome do outro contato";
translations[OTHER_CONTACT_OCCUPATION] = "Ocupação do outro contato";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Número de telefone do outro contato";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Endereço de e-mail do outro contato";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Produto que você selecionou é fabricado por outra empresa, podemos fornecer suas informações de contato a eles se tiverem dúvidas adicionais sobre seu relatório?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "O cliente solicitou explicitamente os resultados da investigação?";
translations[EXPLICITLY_REQUEST_CREDIT] = "O cliente solicitou crédito explicitamente?";
translations[PRODUCT_FROM_VANTIVE] = "O cliente comprou o produto diretamente da Vantive?";
translations[QUANTITY_REQUESTED_CREDIT] = "Número (s) do lote e quantidade solicitada para crédito:";
translations[ENTER_OCCUPATION] = "Inserir ocupação";
translations[LOT_QUANTITY_NUMBER] = "Inserir número e quantidade do lote";
translations[WHOLESALERS_NAME] = "Qual é o nome e a localização do distribuidor (cidade, estado)";
translations[PLACE_WHOLESALERS_NAME] = "Qual é o nome e a localização do distribuidor (cidade, estado)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Adicionar produto à grade";
translations[SAVE] = "Salvar";
translations[CANCEL] = "Cancelar";
translations[ADD_MORE_PRODUCTS] = "Adicionar mais produtos";
translations[REPORTER_ADDRESS] = "Endereço do notificador";
translations[ATTACHMENTS] = "Anexos";
translations[DATE_OF_EVENT] = "Data do evento";
translations[DATE_OF_EVENT_MSG] = "A data do evento não pode ser após a data que o funcionário da Vantive foi notificado pela primeira vez. Por favor, inserir uma data válida.";
translations[HELP_DATE_OF_EVENT] = "se houver várias datas conhecidas em que o evento ocorreu, preencha um formulário para cada data.";
translations[DATE_VANTIVE_EMPLOYEE] = "Data em que o funcionário da Vantive foi notificado pela primeira vez";
translations[DURING_WHAT_PROCESS] = "Durante quais etapas do processo o evento ocorreu?";
translations[WAS_THE_PATIENT] = "O paciente estava conectado (tratamento em andamento) no momento do evento?";
translations[WERE_YOU_CONNECTED] = "Você estava conectado (tratamento em andamento) no momento do evento?";
translations[PROVIDE_ANY_ADDITIONAL] = "Forneça todos os detalhes adicionais relacionados ao evento/problema";
translations[HELP_YOU_IDENTIFIED_MORE] = "Se você identificou mais de um produto e problema, por favor, esclareça quais produtos tiveram tais problemas relatados.";
translations[ENTER_DETAILS] = "Inserir os detalhes";
translations[PROVIDE_ANY_ATTACHMENT] = "Forneça qualquer anexo conforme aplicável";
translations[WAS_NEGATIVE_MEDICAL] = "Houve algum impacto médico negativo, sintoma (s) ou lesão como resultado do evento?";
translations[WAS_MEDICAL_INTERVENTION] = "Foi realizado tratamento,  intervenção médica ou escalonamento de cuidados para neutralizar o evento relatado?";
translations[PROVIDE_DETAILS] = "Forneça detalhes";
translations[REQUIRED_TREATMENT] = "Tratamento necessário/intervenção médica";
translations[ENTER_TREATMENT] = "Inserir o tipo tratamento";
translations[RELEVANT_TESTS] = "Testes relevantes, incluindo dados laboratoriais:";
translations[HELP_RELEVANT_TESTS] = "Inserir testes relevantes";
translations[RELEVANT_MEDICAL_HISTORY] = "Histórico médico relevante, incluindo condições médicas pré-existentes:";
translations[ENTER_HISTORY] = "Inserir o histórico";
translations[PATIENT_NAME] = "Nome do paciente";
translations[PATIENT_INITIALS] = "Iniciais ou nome completo do paciente. Se houver vários pacientes envolvidos, preencha um formulário para cada paciente.";
translations[PATIENT_PHONE_NUMBER] = "Número de telefone do paciente";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Não desejo fornecer";
translations[PATIENT_EMAIL_ADDRESS] = "Endereço de e-mail do paciente";
translations[PATIENT_ADDRESS] = "Endereço do paciente";
translations[SAME_ADDRESS] = "Mesmo endereço";
translations[DRUG_BEING_USED] = "Um medicamento Vantive estava sendo usado no momento do evento?";
translations[PATIENT_IDENTIFIER] = "Identificação do paciente ";
translations[PATIENT_AGE_OR_DOB] = "Idade do paciente ou DOB";
translations[ENTER_PATIENT_AGE] = "dd/mm/aaaa, Inserir a idade do paciente";
translations[PATIENT_GENDER] = "Gênero do paciente";
translations[PATIENT_WEIGHT] = "Peso do paciente";
translations[ENTER_WEIGHT] = "Inserir o peso";
translations[PATIENT_WEIGHT_UNIT] = "Unidade de peso do paciente";
translations[MY_NAME] = "Meu nome";
translations[ENTER_IN_YOUR_CONTACT] = "Inserir suas informações de contato";
translations[MY_PHONE_NUMBER] = "Meu número de telefone";
translations[MY_EMAIL_ADDRESS] = "Meu endereço de e-mail";
translations[MY_ADDRESS] = "Meu endereço";
translations[NAME_OF_VANTIVE_DRUG] = "Nome do medicamento Vantive";
translations[ENTER_DRUG_NAME] = "Inserir o nome do medicamento";
translations[PLEASE_PROVIDE_THE_NAME] = "Forneça o nome ou código do produto do medicamento Vantive. Forneça o nome de todos os medicamentos da Vantive usados ​​no momento do problema relatado";
translations[SELECT_THE_COMPONENT] = "Selecione o componente que apresentou o problema";
translations[USE_THE_DIAGRAM] = "Use o diagrama acima (Figura 1) para determinar a localização do descartável danificado.";
translations[TYPE_OF_DAMAGE] = "Descreva o tipo de dano";
translations[PLEASE_ENTER_VALUE] = "Por favor, Inserir o valor";
translations[WAS_THE_PRODUCT_KINKED] = "O produto foi torcido, rachado, dobrado, cortado, etc?";
translations[WERE_ANY_CLEANING] = "Alguma solução de limpeza, solventes ou produto de limpeza foram usados no Produto?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Qual foi o nome/marca do produto de limpeza e como ele foi usado?";
translations[NOTE_VANTIVE_LABELING] = "O rótulo Vantive orienta que não se aplique alvejante, peróxido de hidrogênio, álcool ou antisséptico contendo álcool ao equipo. O uso desses produtos pode fazer com que o produto desenvolva rachaduras.";
translations[SELECT_ALL_THAT_APPLY] = "Selecione tudo o que se aplica";
translations[DID_FOLLOWING_OCCUR] = "Alguma das opções a seguir ocorreu?";
translations[SELECT_THE_LOCATION] = "Selecione o local com o dano no Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "O produto foi exposto a alguma força excessiva (ou seja,batida, colisão, queda, etc.) antes que o problema ocorresse?";
translations[HOW_LONG_TRANSFER] = "Há quanto tempo o equipo de transferências está em uso?";
translations[WAS_THERE_DIFFICULTY] = "Houve alguma dificuldade ao abrir ou fechar o twist clamp?";
translations[WAS_DEVICE_OR_TOOL] = "Um dispositivo ou ferramenta foi usado para abrir ou fechar o twist clamp?";
translations[DESCRIBE_HOW_PRODUCT] = "Descreva qual a dificuldade de usar o produto (Selecione tudo o que se aplica)";
translations[DID_YOU_OBSERVE] = "Você observou algum dano (por exemplo, corte, furo, rachadura) no produto?";
translations[WERE_DIFFICULTIES_PUTTING] = "Houve alguma dificuldade em colocar o Minicap no equipo de Transferência e torcer no sentido horário até ficar firmemente seguro?";
translations[WAS_THE_TRANSFER] = "O equipo de transferência foi substituído por causa desse evento?";
translations[SELECT_TYPE_OF_FLOW] = "Selecione o tipo de problema de fluxo";
translations[WAS_ANYTHING_BLOCKING] = "Havia alguma coisa bloqueando o fluxo?";
translations[WAS_ANY_ALARM] = "Houve algum alarme?";
translations[SELECT_BEST_DESCRIBE] = "Selecione a opção que melhor descreva o problema";
translations[WERE_THE_MINICAPS] = "Os Minicaps foram expostos ou armazenados em um ambiente quente/frio?";
translations[WAS_THE_SPONGE_VISIBLE] = "A esponja era visível dentro do Minicap?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "Onde está localizado  a  partícula/material estranho?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Descreva a localização, o tamanho, a forma e a cor exatos da partícula/material estranho:";
translations[WAS_THE_PARTICULATE_MATTER] = "A partícula/material estranho foi incorporado no produto?";
translations[DOES_THE_PARTICULATE_MATER] = "A partícula /material estranho parece ser pedaços do produto?";
translations[WHAT_COMPONENT_DOES] = "De que componente  a partícula parece ser?";
translations[SELECT_CONNECTION_ISSUE] = "Selecione a opção que melhor descreve o problema de conexão";
translations[WERE_ASSIST_DEVICES] = "Algum dispositivo ou ferramentas de assistência foram usados para fazer a conexão do descartável?";
translations[WERE_ANY_DIFFICULTIES] = "Alguma dificuldade durante a conexão inicial foi notada ou desconexão?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Forneça as informações do segundo produto envolvido no problema de conexão";
translations[WERE_THE_SPIKE_LUER] = "Os conectores luer/Spike foram girados no sentido horário até estarem firmemente presos?";
translations[VANTIVE_LABELING_STATES] = "O rótulo Vantive orienta  para garantir que todas as conexões descartáveis estejam seguras e ajustadas antes de iniciar a terapia.";
translations[WERE_PETS_OR_ANIMALS] = "Haviam animais que pudessem ter danificado o equipo descartável?";
translations[VANTIVE_LABELING_CONTAMINATION] = "O rótulo Vantive orienta que se um animal morder os suprimentos descartáveis, uma contaminação das vias do fluido pode ocorrer. Para reduzir esse risco, não faça diálise na mesma sala que animais de estimação.";
translations[WERE_OTHER_ISSUES] = "Houve outros problemas ou dificuldades associados ao Spike/conector luer (ou seja, rachado, deformado, dobrado etc.)?";
translations[WAS_MINICAP_TWISTED] = "O Minicap foi torcido no sentido horário no conector do equipo de transferência até ficar firmemente preso?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Houve alguma dificuldade em colocar o Minicap no equipo de Transferências?";
translations[DID_TRANSFER_SET_CONNECTORS] = "Os conectores do equipo de transferência tiveram algum dano visível ou resíduo nas roscas?";
translations[WHAT_WAS_THE_ALARM] = "Qual foi o alarme?";
translations[WHERE_OBSERVED_DAMAGE] = "Onde o dano foi observado (selecione todos os que se aplicam)?";
translations[SELECT_THE_TYPE_OBSERVED] = "Selecione o tipo do dano observado (selecione tudo o que se aplica):";
translations[DID_DAMAGE_CAUSE_LEAK] = "O dano causou vazamento?";
translations[WAS_THE_SHIPPING_CARTON] = "A caixa de transporte foi aberta com um objeto pontiagudo?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Selecione o tipo de problema de fluxo observado";
translations[HOW_LONG_WAS_STORAGE] = "Quanto tempo ficou em armazenamento antes do produto expirado ser encontrado?";
translations[WAS_THERE_AN_ADAPTER] = "Havia um adaptador, ou qualquer outro (s) dispositivo (s), usado com o produto?";
translations[NAME_AND_MODEL] = "Qual é o nome e o modelo do adaptador ou de qualquer outro dispositivo usado?";
translations[NAME_VAPORIZER] = "Qual é o nome e o modelo do vaporizador?";
translations[WAS_VIAL_INVERTED] = "O frasco anexado foi invertido antes de despejar a solução no frasco para injetáveis?";
translations[WHAT_VIAL_USED] = "Quais são as informações do produto para o frasco usado?";
translations[DRUG_NAME_MANUFACTURER] = "Nome do medicamento, fabricante, tamanho do frasco";
translations[WERE_BREAK_FRANGIBLE] = "Você foi capaz de quebrar o frangible corretamente usando um movimento para frente e para trás?";
translations[WAS_ALARM_ASSOCIATED] = "Houve algum alarme associado a ausência de fluxo?";
translations[WHAT_PART_DISCOLORED] = "Qual parte do produto foi relatada com alteração de cor ? (selecione tudo o que se aplica)";
translations[DESCRIBE_DISCOLORATION] = "Descreva a descoloração (descreva cor, nuance, tonalidade, sombra, etc.):";
translations[HOW_PRODUCT_STORED] = "Como o produto foi armazenado?";
translations[DOES_DISCOLORATION_APPEAR] = "A descoloração parece ser opaca, nebulosa, turva e/ou tem marcas circulares/hexagonais?";
translations[WHICH_CHAMBER_DISCOLORED] = "Qual câmara estava descolorida na bolsa?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "O lacre destacável ou frangible entre câmaras já estava quebrado/ativado?";
translations[WAS_DISCOLORATION_NOTICED] = "A descoloração foi notada através do visor vaporizador?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Selecione a opção que descreve mais especificamente o problema:";
translations[WHAT_DEVICE_HAD_ALARM] = "Qual dispositivo tinha o alarme?";
translations[WHAT_MISSING_MISASSEMBLED] = "Qual componente estava ausente ou foi montado incorretamente ?";
translations[RECONSTITUTION_ISSUE] = "Forneça uma descrição mais específica do problema da Reconstituição";
translations[WHAT_MEDICATION_SOLUTION] = "Com qual medicação/solução o produto estava sendo reconstituído?";
translations[WHAT_VOLUME_MEDICATION] = "Qual foi o volume de medicação/solução usado para reconstituir?";
translations[WHAT_DEVICES_RECONSTITUTION] = "Quais outros dispositivos foram usados durante a reconstituição (nome/fabricante, tamanho/calibre da agulha, etc.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "O produto foi exposto ao calor?";
translations[DESCRIBE_EXPOSURE] = "Descreva a exposição (temperatura, por quanto tempo, etc.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Qual técnica foi usada para ativar a solução?";
translations[WAS_DAMAGE_OBSERVED] = "Houve algum dano observado ao produto antes da ativação?";
translations[DESCRIBE_THE_DAMAGE] = "Descreva o dano:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Aproximadamente, quanto de solução ou pó não foi enchido o suficiente ou apresentou o excesso de enchimento?";
translations[WAS_LEAK_OBSERVED] = "Houve algum vazamento observado?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Qual componente ou recurso do produto é difícil de usar?";
translations[HOW_WAS_DIFFICULT_USE] = "Como o produto foi difícil de usar?";
translations[WHERE_MATTER_FOREIGN] = "Onde estava localizada a partícula/material estranho?";
translations[DOES_PARTICULATE_MATTER] = "A partícula/material estranho parece ser peças de material do produto?";
translations[DESCRIBE_EXACT_LOCATION] = "Descreva a localização, a cor, o tamanho, a forma e a textura exatos da partícula/material estranho.";
translations[WAS_MATTER_FOREIGN] = "A partícula/material estranho estava embutido no produto (não se movendo livremente)?";
translations[WHEN_MATTER_FOREIGN] = "Quando foi observada a partícula/material estranho?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Forneça informações sobre o produto para o medicamento adicionado:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Nome do produto, código do produto, número do lote do produto, Nome da marca";
translations[DESCRIBE_SPIKING] = "Descreva a técnica de perfuração ou reconstituição que foi usada:";
translations[INCLUDE_NEEDLE] = "Inclui tamanho/calibre da agulha, ângulo de perfuração, número de tentativas";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Qual equipo de administração ou dispositivo de reconstituição foi usado?";
translations[INCLUDE_MANUFACTURER] = "Incluir fabricante, nome do produto, código do produto, lote de produtos";
translations[WAS_MEDICATION_ADDITIVE] = "Uma solução de medicação, aditivo ou reconstituição foi adicionada ao produto?";
translations[WHAT_MEDICATION_ADDITIVE] = "Que solução de medicação, aditivo ou reconstituição foi adicionada?";
translations[WHAT_STATE_OF_PRODUCT] = "Qual foi o estado do produto quando a turvação/precipitado foi observada?";
translations[AFTER_UNITS_SAT] = "Depois que as unidades se estabilizaram e atingiram a temperatura ambiente, a turvação/precipitado desapareceu?";
translations[DID_ATTEMPT_AGITATE] = "Você tentou agitar a unidade?";
translations[DID_PRECIPITATE_DISSOLVE] = "O precipitado se dissolveu?";
translations[WHAT_STORAGE_TEMPERATURE] = "Quais foram a temperatura e as condições de armazenamento do produto?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Fornecer temperatura, localização, armazenado dentro ou fora do overpouch/cartucho/caixa intermediária, unidades individuais";
translations[ARE_TEMPERATURE_LOGS] = "Os registros de temperatura para o (s) congelador (s) em que o produto está armazenado estão disponíveis?";
translations[LOGS_CAN_BE_ATTACHED] = "Os registros podem ser anexados diretamente a este formulário, se disponíveis no momento do envio";
translations[IS_THE_STORAGE_UNIT] = "A unidade de armazenamento (freezer ou refrigerador) é calibrada e controlada por temperatura?";
translations[HOW_PRODUCT_THAWED] = "Como o produto foi descongelado?";
translations[WHAT_STORAGE_CONDITIONS] = "Quais foram as condições de armazenamento do produto? (temperatura, localização, armazenado dentro ou fora do overpouch/cartucho)";
translations[WAS_ANY_DAMAGE] = "Houve algum dano ao produto ou problema observado?";
translations[MORE_SPECIFIC_INFORMATION] = "Forneça informações mais específicas:";
translations[WHAT_PURPOSE_INDICATION] = "Qual foi o propósito/indicação do tratamento para o paciente?";
translations[WHAT_ROUTE_ADMINISTRATION] = "Qual era a via de administração?";
translations[WHAT_DATE_ADMINISTRATION] = "Qual foi a data de administração e duração?";
translations[WHAT_DOSAGE_STRENGTH] = "Qual foi a dosagem administrada ao paciente?";
translations[WAS_RECENT_PRESCRIPTION] = "Houve uma alteração recente na prescrição?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Quais foram os detalhes de armazenamento/temperatura do produto (localização do armazenamento/geladeira/congelador, etc.)?";
translations[WERE_ANY_ADJUSTMENTS] = "Houve algum ajuste na solução ou aditivos antes da administração?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Selecione a descrição mais apropriada do problema:";
translations[SELECT_LABELING_ISSUE] = "Selecione a descrição mais apropriada do problema de rotulagem:";
translations[WAS_CONNECTION_SECURE] = "A conexão estava segura e totalmente apertada?";
translations[WAS_EXPIRED_PRODUCT] = "O produto expirado foi administrado a um paciente?";
translations[WAS_COMPONENT_DAMAGED] = "Houve algum componente danificado?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Houve alguma anormalidade/dano notado no produto?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Qual é o número do seu pedido de compra?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "Qual foi a data da administração?";
translations[WHAT_WAS_EXPIRATION_DATE] = "Qual foi a data de validade do produto?";
translations[DESCRIBE_WAS_INCORRECT] = "Descreva o que estava incorreto, incompleto, ausente, ilegível no rótulo ou o que era muito semelhante (a outro produto) no rótulo:";
translations[WHAT_SCANNER_USED] = "Que tipo de scanner foi usado?";
translations[WAS_OVERPOUCH_POUCH] = "O produto ainda estava no overpouch/bolsa durante a digitalização?";
translations[WHAT_BACKGROUND_COLOR] = "Qual era a cor de fundo ao digitalizar?";
translations[DO_ALL_OF_THE_LABELS] = "Todas as etiquetas (produto, caixa/cartucho, envio/distribuição) têm as mesmas informações do produto?";
translations[PRODUCT_INFORMATION] = "Informações sobre o produto";
translations[IS_A_BARCODE_SCANNER] = "Um scanner de código de barras é usado em suas instalações?";
translations[HOW_ARE_THESE_PRODUCTS] = "Como esses produtos são armazenados na instalação?";
translations[WHAT_INFORMATION_INCORRECTLY] = "Quais informações foram exibidas incorretamente quando digitalizadas?";
translations[WAS_THERE_LEAK] = "Houve um vazamento ou umidade observado?";
translations[WHERE_LEAK_OBSERVED] = "Onde o vazamento foi observado, qual componente estava vazando?";
translations[WAS_FRANGIBLE_OBSERVED] = "O frangible observado foi quebrado?";
translations[IS_MOISTURE_CLEAR] = "A umidade está com uma coloração clara?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Quem é seu distribuidor?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Qual é o fabricante, o nome do medicamento e o tamanho do frasco usado?";
translations[WHAT_GAUGE_NEEDLE] = "Qual é o calibre da agulha usado, fabricante e número de vezes que o local foi perfurado?";
translations[WHAT_ADMINISTRATION_SET] = "Qual equipo de administração foi usado?";
translations[WAS_DIFFICULTY_SPIKING] = "Houve dificuldade em perfurar?";
translations[WERE_FOLLOWING_SCENARIOS] = "Algum dos seguintes cenários ocorreu com o vazamento?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "O frangible observou ter dano ou defeito?";
translations[WHAT_AMOUNT_PRESSURE] = "Que quantidade de pressão foi aplicada e por qual duração?";
translations[WAS_BAG_COMPLETELY] = "A bolsa foi completamente e corretamente inserida na cavidade?";
translations[WHAT_MANUFACTURER_MODEL] = "Qual é o fabricante, modelo e tamanho da cavidade de pressão?";
translations[WHAT_PRESSURE_PRIOR] = "Qual era a pressão antes do vazamento ser detectado?";
translations[LIST_THE_VAPORIZER] = "Liste o fabricante do vaporizador e o nome/modelo";
translations[APPROXIMATELY_HOW_MUCH] = "Aproximadamente quanto líquido foi derramado?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "A garrafa era difícil de inserir no vaporizador?";
translations[WERE_VISIBLE_DEFECTS] = "Houve algum defeito visível?";
translations[SELECT_THE_OPTION] = "Selecione a opção que melhor descreve o problema de conexão";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Forneça as informações do segundo produto envolvido no problema de conexão";
translations[WHICH_PART_SEPARATED] = "Quais partes do produto foram separadas?";
translations[WHAT_COMPONENT_DISCOLORED] = "Qual componente está descolorido?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Selecione a opção que melhor descreve a descoloração:";
translations[WAS_THE_SET_DISCOLORED] = "O equipo estava descolorido quando foi removido do pacote?";
translations[DID_SET_CHANGE_COLOR] = "O  equipo mudou de cor depois de adicionar medicação?";
translations[WHAT_MEDICATION_ADDED] = "Qual medicamento foi adicionado antes da mudança de cor?";
translations[WHERE_MATERIAL_LOCATED] = "Onde estava localizado  a particulado/material estranho?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Descreva a partícula/material estranho (aparência/cor/ tamanho):";
translations[WAS_EMBEDDED_PLASTIC] = "A partícula/material estranho estava solto ou embutido no plástico?";
translations[WAS_THERE_A_PRECIPITATE] = "Houve um precipitado ou mudança na cor da solução que não era esperado?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Quais medicamentos/soluções foram infundidos através do conjunto?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Onde foi o dano ou quais componentes foram afetados (selecione todos os que se aplicam)?";
translations[WHAT_DAMAGE_ISSUE] = "Que tipo de dano/problema foi observado (selecione todos os que se aplicam)?";
translations[DID_ISSUE_RESULT] = "Esse problema resultou em vazamento?";
translations[WAS_PATIENT_CONNECTED] = "O paciente estava conectado ao produto?";
translations[WAS_PRODUCT_REPLACED] = "O produto foi substituído por um novo produto?";
translations[WHICH_SITUATION_BEST] = "Qual situação melhor descreve o problema de separação/conexão";
translations[SELECT_MOST_LABELING_ISSUE] = "Selecione a descrição mais apropriada do problema de rotulagem:";
translations[WHAT_INFORMATION_DISPLAYED] = "Quais informações foram exibidas?";
translations[WHAT_SCANNER_WAS_USED] = "Que tipo de scanner foi usado?";
translations[INCLUDE_THE_MODEL_NAME] = "Inclua o nome do modelo";
translations[WAS_PRODUCT_ORDERED] = "O produto foi  comprado diretamente da Vantive ou de outro distribuidor?";
translations[WHERE_LEAK_COMING] = "De onde vem o vazamento (selecione tudo o que se aplica)?";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Algum dos seguintes cenários ocorreu com o vazamento?";
translations[WAS_POWER_INJECTOR] = "O produto foi usado com um injetor eletrônico?";
translations[WHAT_INJECTOR_USED] = "Qual injetor eletrônico foi usado?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Fabricante, nome do produto, código do produto, lote de produtos";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Descreva o que estava incorreto, incompleto, ausente, ilegível ou alterado no rótulo:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Forneça as informações de produto do segundo produto envolvido na desconexão";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Quais componentes foram encontrados para ter uma rachadura ou quebra?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Descreva a localização exata na tubulação que tinha o corte, o furo ou rasgo.";
translations[WAS_LEAK_ORIGINATING] = "Foi o vazamento originado da abertura do local da injeção";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Forneça as informações de produto do segundo produto envolvido no problema de desconexão/conexão";
translations[WHICH_SPECIFIC_BONDED] = "Quais componentes específicos estavam separados?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Houve alguma irregularidade/dano visível no produto/componentes envolvidos";
translations[WAS_SUCCESSFUL_CONNECTION] = "Foi estabelecida uma conexão ou desconexão bem-sucedida (sem ter que substituir o produto)?";
translations[WAS_TOOL_USED_ASSIST] = "Uma ferramenta foi usada para auxiliar na conexão/desconexão?";
translations[WERE_LUER_CONNECTIONS] = "Todas as conexões Luer foram verificadas para garantir que elas estavam seguras antes do uso (conforme rótulo)";
translations[WAS_PRODUCT_SECURELY] = "O produto estava conectado com segurança a outro produto antes da desconexão?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Qual situação melhor descreve o problema de fluxo?";
translations[WHAT_FLOWING_BACKWARDS] = "O que estava fluindo ao contrário?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Descreva os componentes de onde o refluxo começou para onde ele parou:";
translations[DO_SITUATIONS_APPLY] = "Alguma dessas situações se aplica a este evento?";
translations[WHICH_SPECIFIC_AREA] = "Qual área específica do  equipo ou componente foi associada aos problemas de fluxo?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "O fluxo foi visto anteriormente através do equipo ou componente?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "Algum dos seguintes foi observado:";
translations[WHERE_SIMULTANEOUS_FLOW] = "Onde estava o fluxo simultâneo ?";
translations[WHAT_TYPE_HANGER] = "Que tipo de suporte foi usado?";
translations[WHAT_WAS_HANGER_LENGTH] = "Qual era  a altura do suporte e/ou fabricante?";
translations[WHICH_BAG_LOWER] = "Qual bolsa estava mais baixa?";
translations[WHAT_Y_SITE_WAS] = "A qual o conector tipo Y o equipo secundário estava conectado?";
translations[WHAT_COMPONENT_WITHIN] = "Qual componente dentro do equipo não pode ser limpo de solução ou sangue?";
translations[WAS_COMPONENT_SET_REPLACED] = "O componente/conjunto foi substituído depois de não conseguir ser limpo?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Qual foi o volume de fluido a ser infundido ao paciente e o período de tempo prescrito?";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Qual foi o volume de fluido realmente infundido no paciente em que período de tempo?";
translations[WAS_USED_WITH_PUMP] = "O equipo foi usado com uma bomba?";
translations[DID_CLAMP_FAIL] = "Um grampo não parou ou controlou o fluxo?";
translations[WHAT_CLAMP_FAILED] = "Qual grampo falhou?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Houve algum problema observado com o grampo?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Alguma dessas outras situações descreve o problema do produto (selecione tudo o que se aplica)?";
translations[DESCRIBE_ALARM_OBSERVED] = "Descreva o alarme observado:";
translations[INCLUDE_ANY_MESSAGES] = "Inclua mensagens e códigos de erro associados ao alarme";
translations[WHICH_CLAMP_HAD_ISSUE] = "Qual grampo teve o problema?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Que tipo de problema de grampo foi experimentado (selecione todos os que se aplicam)?";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Selecione o cenário que melhor descreve o problema:";
translations[PROVIDE_MORE_DETAILS] = "Forneça mais detalhes sobre como o produto era difícil de usar:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Forneça mais detalhes sobre como as instruções eram difíceis de seguir/entender:";
translations[DESCRIBE_THE_SMELL] = "Descreva o cheiro e de onde ele estava vindo:";
translations[WAS_ISSUES_WITH_SET] = "Houve algum problema observado com o equipo?";
translations[WHERE_LEAK_LOCATED] = "Onde no produto o vazamento estava localizado?";
translations[DID_OCCUR_WITH_LEAK] = "Alguma das seguintes opções ocorreu com o vazamento?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Forneça as informações de produto do segundo produto envolvido na desconexão";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Algum dos seguintes cenários ocorreu com o vazamento?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Onde o produto foi danificado?";
translations[SELECT_ALL_APPLY] = "Selecione tudo o que se aplica";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Descreva o dano observado";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Qual componente do produto estava descolorido?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Descreva a cor observada (nuance, tonalidade, sombra, etc.):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "Overpouch interno ou externo, temperatura, exposição à luz, etc.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Descreva a localização, o tamanho, a forma e a cor exatos da partícula/material estranho:";
translations[DOES_THE_PARTICULATE_MATTER] = "A partícula/material estranho parece ser material do produto?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "A partícula/material estranho foi incorporado?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "A partícula /material estranho parece ser pedaços do produto?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Onde o problema ocorreu no produto?";
translations[LIST_COMPONENTS_IF] = "Liste componentes. Se um segundo produto estiver envolvido, forneça Fabricante, nome do produto, código do produto, lote de produtos";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Houve alguma irregularidade/dano visível observado?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Selecione a opção que melhor descreve o problema de fluxo";
translations[DESCRIBE_IRREGULARITIES] = "Descreva irregularidades/danos e se o dano foi observado antes da conexão/desconexão ou se ocorreu durante a conexão/desconexão";
translations[HOW_PRODUCT_SETUP] = "Como foi a configuração do produto?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Selecione a descrição mais apropriada do problema de rotulagem:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Descreva o que estava incorreto, incompleto, ausente, ilegível no rótulo ou o que era muito semelhante (a outro produto) no rótulo:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "O produto dentro da caixa de transporte foi danificado?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Qual produto deveria ser recebido?";
translations[IF_PRODUCT_CODE_NOT] = "Se o código do produto não estiver disponível, forneça a descrição do produto";
translations[WAS_THE_CASE_MISSING] = " Faltava gelo seco ou gel refrigerado no contêiner?";
translations[WHAT_CARRIER_DELIVERED] = "Qual transportadora entregou seu produto?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Qual é o número da ordem de compra?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Qual era a quantidade de unidades ausentes?";
translations[WAS_EXPIRED_PRODUCT_USE] = "O produto expirado foi usado?";
translations[APPLY_TO_EACH_UNIT] = "Se esse problema ocorreu com mais de uma quantidade, as perguntas abaixo se aplicam a cada quantidade.";
translations[TERMS_CONDITIONS] = "Termos e Condições ";
translations[PRIVACY_POLICY] = "Política Privacidade ";
translations[PRIVACY_NOTICE] = "Aviso de Privacidade";
translations[COOKIE_POLICY] = "Política Cookies";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Perguntado/desconhecido";
translations[OPTION_FUNCTIONOPTIONS_VANTIVE_EMPLOYEE] = "Funcionário Vantive";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Cuidador";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distribuidor";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Profissional da saúde";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Paciente";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Outro";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Após o uso";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Antes do uso";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Durante a configuração/preparação/composição";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Durante a terapia";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Várias etapas";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Não especificado";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Membro da família";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Enfermeira";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Enfermeira Chefe";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Outro profissional de saúde";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Médico";
translations[OPTION_UNITOPTIONS_BOXES] = "Caixas";
translations[OPTION_UNITOPTIONS_PALLETS] = "Paletes";
translations[OPTION_UNITOPTIONS_UNITS] = "Unidades";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Condição de Alarme";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Dano";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Difícil de usar";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Descolorido";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Problemas de fluxo";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Problemas de rotulagem";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Vazamento / Umidade Excessiva";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Material particulado/material estranho";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Reação do Paciente/Evento Adverso";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Consulta do produto";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Separação / Conexão";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Problemas de envio/produto expirado";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Feminino";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Indiferenciado";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Masculino";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Recusar-se a responder";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Administrador/Supervisor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Engenheiro Biomédico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Representante da empresa";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Dentista";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Distribuidor";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Membro da família";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Usuário";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Enfermeira";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Enfermeira Chefe";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Outro profissional de saúde";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Farmacêutico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Técnico farmacêutico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Médico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Paciente";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Gerente de risco";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Outros";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Outro contato adicional";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Contacte-me";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = " Contato Outro";
translations[OPTION_REPORTEDTOOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "China FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Health Canadá";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Japão)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Austrália)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Um animal de estimação ou animal poderiam ter causado o problema.                                                                                                                                                                                                           ";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Um objeto ou ferramenta afiada foi usado para abrir a caixa ou sobrebolsa";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "O produto foi exposto a força excessiva (ou seja, batida, colisão, queda, etc.) antes que o problema ocorresse.";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "O produto foi exposto ou armazenado em um ambiente quente/frio.";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Cartucho/Blister";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Pouch/Bolsa";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "O equipo  de transferência estava muito apertado";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "O equipo o de transferência estava muito solto";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "O equipo de transferência foi incapaz de fechar completamente";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "O equipo de transferência foi incapaz de abrir completamente";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "O grampo de torção era tão apertado que o equipo de transferência não foi capaz de abrir.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "O grampo de torção estava tão apertado que o equipo de transferência não foi capaz de fechar em todos os";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Sim - houve danos para/algo errado com os segmentos do o equipo de transferência, impedindo que ele se fechasse corretamente";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Sim - o Minicap foi apertado demais para o equipo de transferência manualmente ou com um dispositivo de ferramenta/assistência";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Completamente parado e sem fluxo de fluido";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Restrito ou fluxo parcial (fluxo lento)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Sangue coagulado";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibrina";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Torção";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Partícula";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Material do Produto";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Excesso de iodo (marrom) identificado na conexão ou na embalagem";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Excesso de umidade (gotas claras) identificadas na embalagem";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Bolsa de alumínio danificada antes de abrir";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Pacote/caixa aberta ou danificada antes do uso";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Esponja seca e branca";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Esponja secou com uma cor acastanhada";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = " Na embalagem secundária/sobrebolsa";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "Dentro do produto/fluido";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Dentro da caixa de transporte";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Na parte externa do produto";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = " Na parte externa da embalagem secundária/sobrebolsa";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = " No exterior da caixa de transporte";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Dificuldades em conectar o produto a outro produto";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Dificuldades em desconectar o produto de outro produto";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separação de componentes em um único produto";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separação/desconexão do produto de outro produto";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "SIM - resíduo no fio";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "SIM - danos visíveis";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Sim - Outro (texto livre)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangível";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Orifício de Suspensão";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Porta de injeção/enchimento";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Porta de membrana";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Sobrebolsa/bolsa";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Mancha";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Rolha de Borracha";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Caixa de transporte";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Faixa retrátil";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Recipiente de solução";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Protetor de Ponta";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Selo inviolável (envoltório retrátil)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Dobrado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Quebrado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Rachado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Cortar";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Deformado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Descamação";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Buraco";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Retorcido";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Derretido";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Separação da Camada de Remendo";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Despedaçado (vidro)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Cortado";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Rasgado";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "A solução não fluiria de jeito nenhum";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "A solução fluiria muito lentamente";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "A solução não fluiria (ou fluiria lentamente) durante a reconstituição ou composição";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Fraco";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Recipiente";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Orifício de Suspensão";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Revestimento";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Sobrebolsa/bolsa";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Indicador de oxigênio";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Mancha";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Portas";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Solução";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Protetor de Ponta";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Câmara de Aminoácidos";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Câmara Dextrose";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Câmara Lipídica";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Câmara Inferior";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Câmara Superior";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Selo rompido/rompido";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Produto/peça mal montado";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Componente ausente";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Separação/Desconexão do(s) Componente(s) Ligado(s)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Produto preenchido";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Produto Não preenchido";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Problema de reconstituição";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "Na embalagem secundária/sobrebolsa";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "Dentro da caixa de transporte";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "No exterior da caixa de transporte";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Dentro da solução/caminho do fluido";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "Dentro do reservatório do vaporizador (vidro)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "Na superfície externa do produto";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "Na parte externa da embalagem secundária/sobrebolsa";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "No absorvedor de oxigênio";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "No adesivo transdérmico";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangível";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Partículas de vidro";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Porta";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Rolha de borracha";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Tubulação";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Depois de adicionar outro medicamento ou após a reconstituição (frascos)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Antes de aumentar ou reconstituir";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "Frio (descongelado, mas ainda não  em temperatura ambiente)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Congelado";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Parcialmente descongelado (cristais de gelo em solução)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Temperaturaambiente";
translations[OPTION_PRODUCTTHAWEDOPTIONS_VANTIVE_THAWING] = "Unidade de descongelamento da Vantive";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Deixado no balcão à temperatura ambiente";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Frigorífico";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Sim - houve evidência de danos durante o transporte";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Sim - houve um vazamento observado";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = " Sim - houve um furo ou selo incompleto na sobrebolsa";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = " Sim - houve dificuldade em aumentar ou reconstituir";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = " Sim - houve dificuldade em quebrar o frangível";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = " Sim - houve cristalização ou precipitação de solução";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = " Sim - houve nebulosa/precipitado no produto Frozen Galaxy";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "O produto não forneceu o efeito pretendido ou foi ineficaz (falta de efeito)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Efeito não intencional/reação. Especifique: (texto livre)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Caixa de transporte danificada durante a entrega";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Produto expirado entregue";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Produto expirado encontrado";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema de código de barras - Informações incorretas exibidas quando digitalizadas";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Dificuldades em escanear/código de barras não escaneável";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Produto expirado entregue";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Produto expirado encontrado no inventário";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Rótulo ilegível";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Rótulo incorreto";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Rótulo incompleto";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Rótulo muito semelhante a outro produto";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "As etiquetas (produto, caixa/caixa, lista de envio) não possuem as mesmas informações do produto";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Código de barras ausente";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "Caixa/caixa contém produto errado ou produto misturado";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Caixa de transporte danificada durante a entrega";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Unidades extras foram recebidas";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Produto expirado entregue";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Produto expirado encontrado";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Parte da caixa foi aberta ou não selada";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "As informações do produto na caixa e na etiqueta de distribuição não correspondem ao produto dentro da caixa";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Faltavam unidades";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Rótulo ausênte";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Data de validade";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Número de lote";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "Número NDC";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Gotas/umidade dentro da sobrebolsa sem vazamento observado";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Vazamento";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Vazamento observado quando o saco é comprimido";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Solução fluindo além do frangible";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Solução dentro da sobrebolsa sem vazamento observado";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Entre a sobrebolsa e o recipiente primário";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Conexão entre dois produtos";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Contêiner - Porta/Tubo de Membrana";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Contêiner - Porta de Injeção/Enchimento";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Recipiente - Orifício de Suspensão";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Recipiente";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangível";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Rolha de Borracha";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Faixa retrátil";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Protetor de Ponta";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Adaptador de frasco";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Tubo aderido";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Danos (furos, rasgos) à embalagem secundária ou caixa intermediária";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposição a extremo quente/ ";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Vazamento frio na interface vaporizador";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Abrir caixa de transporte com um cortador de caixa/objeto afiado                                                                ";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Pets (garrada/mastigado)                                                                                                                                  ";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Bolsa desolução sob pressão com um cavidade de pressão ou outro dispositivo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Tubo aderido";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Dano (furos, rasgos) na embalagem secundária ou na caixa intermediária";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Caixa de transporte danificada durante a entrega";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Exposição ao calor/frio extremo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Vazamento frio na interface vaporizador";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Abrindo a caixa de transporte com um cortador de caixa/objeto pontiagudo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Pets (garrada/mastigado)                                                                                                                                  ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Bolsa desolução sob pressão com um cavidade de pressão ou outro dispositivo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Nenhum dos itens acima.";
translations[NO_DESCRIBE_THE_COLOR] = "Não - descreva a cor (texto livre)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = " Maior que 10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Menos de 1mL";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Fraco";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Cap";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "válvula/gargalo";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Nenhum";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Dificuldades em conectar o produto a outro produto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Dificuldades em desconectar o produto de outro produto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separação de componentes em um único produto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separação/desconexão do produto de outro produto";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Câmara de gotejamento";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Tubulação";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Outro - Por favor especifique (texto livre)";
translations[OTHER_PLEASE_SPECIFY] = "Outro - Por favor especifique (texto livre)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Branco/turvo";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Amarelo/Acastanhado";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = " Outro - Por favor, especifique (Texto livre)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = " Na embalagem primária/bolsa blister";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "Dentro do caminho do fluido IV (na tubulação)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Dentro da caixa de transporte";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = " No exterior da caixa de transporte";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "Fora do caminho do fluido IV (exterior da tubulação)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Integrado";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Solto";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Não aplicável";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = " Descreva a cor (texto livre)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Sim - Mudança de cor";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Sim - Precipitado";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = " Acesso ao site";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = " Bureta";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = " Clamp";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Câmera de gotejamento";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = " Tubo";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = " Filtros";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = " Luer Conector";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Spike";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Componente(s) cortado(s)/rachado(s)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Montagem incorreta do componente - especifique (texto livre)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Componente(s) dobrado";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Componente(s) Solto(s) Dentro da Embalagem";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Componente(s) malformado(s)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Componente ausente";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = " Dificuldade em conectar o produto a outro produto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = " Dificuldade em desconectar o produto de outro produto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Conexão solta";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separação/desconexão do produto de outro produto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Separação entre dois componentes ligados em um único produto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = " Não é possível conectar dois produtos juntos";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = " Não é possível desconectar o produto de outro produto                                                                               ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema de código de barras - Informações incorretas exibidas quando digitalizadas";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Mudança na rotulagem";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Dificuldades em escanear/código de barras não escaneável ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Produto expirado";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Informações incorretas no rótulo";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Código de barras ausente";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Informações ausentes no rótulo";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Produto sem vencimento";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Manchas / Rotulagem Ilegível";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "Embalagem/caixa contém produto errado ou produto misturado";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Caixa de transporte danificada durante a entrega";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Produto expirado entregue";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Produto expirado encontrado";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_VANTIVE] = "Vantive";
translations[OPTION_ORDEREDFROMVANTIVEOPTIONS_DISTRIBUTOR] = "Distribuidor";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Unidades extras foram recebidas";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Parte da caixa foi aberta ou não selada";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "As informações do produto na caixa e na etiqueta de distribuição não correspondem ao produto dentro da caixa";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Faltavam unidades";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Acessar site";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Saída de ar";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Buretas";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Cap";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Sitio de injeção de Clearlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Clamp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Câmara de gotejamento";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filtros";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Sitio de injeção de Interlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Conector Luer";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Spike          ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Tubulação";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Vazamento entre o local da injeção e o tubo";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Local de inserção de agulha";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "sitio de injeção One-Link";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Outros sites de injeção (Texto livre)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = " Rachar/quebrar em componentes rígidos do conjunto";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = " corte/pedaço na tubulação macia";
translations[DISCONNECTION_OF_CONNECTABLE] = "Desconexão de componentes conectáveis/produtos conectados";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Desconexão de componentes conectáveis/produtos conectados";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Separação de componentes ligados";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Sim - Descreva irregularidades/danos (texto livre)";
translations[YES_SPECIFY_THE_TOOL] = "Sim - Especifique a ferramenta usada (Texto livre)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Retorno/Refluxo";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Falha no clamp - Difícil de clampear (mas capaz de fechar eventualmente)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Falha no clamp - Não é possível fechar totalmente";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Falha no clamp - Difícil/Incapaz de Abrir";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Nenhum fluxo";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Infundiu a mais";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Fluxo restrito/lento";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Fluxo simultâneo";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Não foi possível limpar o componente";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Prime impossível";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Infundiu a menos";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Sangue do paciente (não produtos sanguíneos sendo infundidos)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Soluções/produtos do sangue";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Danos de vazamento/furo";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Desconexão";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Vazamento";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "A medicação estava sendo realizada por meio de infusão pressurizada seringa ou bomba IV";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "A bolsa secundária estava mais baixa que a bolsa primária";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "A bolsa secundária estava na mesma altura da bolsa primária";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Coagulação sanguínea";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "O cateter não pôde ser lavado antes de conectar o conjunto";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Tubulação torcida";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Bloqueio do tubo/local de injeção";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Recipiente primário e secundário (piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Duas ou mais derivações fluindo em um equipo de multi-derivações";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = " Dois conjuntos de administração, cada um com sua própria bomba de infusão";
translations[OPTION_HANGERUSEDOPTIONS_VANTIVE_HANGER] = "Vantive Hanger";
translations[OPTION_HANGERUSEDOPTIONS_NON_VANTIVE_HANGER] = "Não Vantive Hanger";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "As bolsas estavam na mesma altura";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Primário";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Secundário";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Médio";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = " Inferior";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Superior";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Sim - Forneça o nome e o código do produto da bomba (texto livre)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Clamp corta fluxo";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Clamp azul corta fluxo";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Pinça Rolete";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Clamp branco";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Sim - o grampo foi quebrado ou rachado";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Ar na linha ";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Clamp danificado";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Odor";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Pinch Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Pinça Rolete";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Slide Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = " Rachado/Quebrado";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = " Difícil de abrir";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = " Difícil de fechar";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = " Ausente";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Não é possível abrir";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Não é possível fechar";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = " Não é possível controlar o fluxo";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = " Difícil de apertar câmara de gotejamento";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = " Instruções eram difíceis de seguir/entender";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "O produto era difícil de usar";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Rachadura/quebra";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Corte/fatia";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Desconexão de componentes conectáveis/produtos conectados";
translations[DISCONNECTION_OF_CONNECTABLE] = "Desconexão de componentes conectáveis/produtos conectados";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Buraco/rasgo";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Separação de componentes ligados";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Tubo aderido";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Dano (furos, rasgos) na embalagem secundária ou na caixa intermediária";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Caixa de transporte danificada durante a entrega";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Exposição ao calor/frio extremo";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Abrindo a caixa de transporte com um cortador de caixa/objeto pontiagudo";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Nenhum dos itens acima.";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Cavidade de pressão ou injetor de pressão usado";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Tubo aderido";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Animais de estimação (com garras/mastigadas)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Produtos";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Caixa/caixa de envio";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "Dentro do produto";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = " Dentro da caixa de transporte";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Na parte externa do produto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Dificuldades para conectar o produto a outro produto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Dificuldades em desconectar o produto de outro produto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Conexão solta";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = " Separação de componentes em um único produto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = " Separação/desconexão do produto de outro produto                                                                                  ";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = " No exterior da caixa de transporte";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = " No interior da embalagem secundária/sobrebolsa";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = " Na parte externa da embalagem secundária/overpouch";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Não fluindo";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "restrito ou parcialmente fluindo";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema de código de barras - Informações incorretas exibidas quando digitalizadas";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Dificuldades em escanear/código de barras não escaneável                                                                                  ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Rótulo ilegível";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Rótulo incorreto";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Rótulo incompleta";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Os rótulos (produto, caixa/caixa, lista de envio) não possuem as mesmas informações do produto";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Etiqueta muito semelhante a outro produto";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Rótulo ausente";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Código de barras ausente";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Produto congelado foi recebido";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "O produto descongelado foi recebido";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Sim, Alarme desconhecido";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Sim, Especifique";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Sim - o equipo de transferências não pôde ser totalmente aberto";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Sim - o equipo de transferências não pôde ser totalmente fechado";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "O grampo de torção era tão apertado que o equipo de transferência não foi capaz de abrir.";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "O grampo de torção estava tão apertado que o equipo de transferência não foi capaz de fechar em todos os";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Caixa ou overpouch";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Clamp Branco de preenchimento ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Cassete";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Conector de Linha de Drenagem e Ring Cap";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Local de Amostragem de Efluentes";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Linhas";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Conectores Luer                                                                                                                                                      ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organizador";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Ring Caps/Tampa protetora na linha do paciente";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Ring Caps/Tampa protetora";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Clamp vermelho na linha do aquecedor";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Soldagem de aderência";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Clamp Branco de abastecimento de de linha";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Adaptador de cateter bege";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Inserção de chip";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Conector femea            ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Conector azul/principal";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Tampa azul (com anel)";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Tampa azul para oclusão";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Tubo de silicone ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Conector de titânio ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "Conector UV Flash ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Twiste Clamp ";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Sim: Descreva o dano (texto livre)";
translations[OPTION_MONTHOPTIONS_JAN] = "Janeiro";
translations[OPTION_MONTHOPTIONS_FEB] = "Fevereiro";
translations[OPTION_MONTHOPTIONS_MAR] = "Março";
translations[OPTION_MONTHOPTIONS_APR] = "Abril";
translations[OPTION_MONTHOPTIONS_MAY] = "Maio";
translations[OPTION_MONTHOPTIONS_JUN] = "Junho";
translations[OPTION_MONTHOPTIONS_JUL] = "Julho";
translations[OPTION_MONTHOPTIONS_AUG] = "Agosto";
translations[OPTION_MONTHOPTIONS_SEP] = "Setembro";
translations[OPTION_MONTHOPTIONS_OCT] = "Outubro";
translations[OPTION_MONTHOPTIONS_NOV] = "Novembro";
translations[OPTION_MONTHOPTIONS_DEC] = "Dezembro";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Outro";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Outro";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Outros (Texto Livre)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Nenhum dos itens acima.";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "Não";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Sim";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "Não";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Sim";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "Não";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Sim";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "Não";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Sim";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Perguntou desconhecido";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "Não";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Desconhecido";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Sim";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "Não";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Sim";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "Não";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Sim";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "Não";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Sim";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "Não";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Sim";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "Não";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Sim";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "Não";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Sim";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "Não";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Sim";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "Não";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Sim";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "Não";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Sim";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "Não";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Sim";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "Não";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Sim";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "Não";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Sim";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "Não";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Sim";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "Não";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "Não";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Sim";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "Não";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Sim";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "Não";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Sim";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "Não";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Sim";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "Não";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Sim";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "Não";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Sim";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "Não";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Sim";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "Não";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Sim";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "Não";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Sim";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "Não";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Sim";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "Não";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "Não";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Sim";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "Não";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Sim";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "Não";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Sim";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "Não";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Desconhecido";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Sim";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "Não";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Sim";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "Não";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Sim";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "Não";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Sim";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "Não";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Sim";
translations[OPTION_vaporizerSightGlassOptions_NO] = "Não";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Desconhecido";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Sim";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "Não";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Sim";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "Não";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Sim";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "Não";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Sim";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "Não";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Sim";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "Não";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Sim";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "Não";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Sim";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "Não";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Sim";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "Não";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Sim";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "Não";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Sim";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "Não";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Desconhecido";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Sim";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "Não";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Sim";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "Não";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Sim";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "Não";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Sim";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "Não";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Sim";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "Não";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Sim";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "Não";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Sim";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "Não";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Sim";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "Não";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Sim";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "Não";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Sim";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Sim";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "Não";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Sim";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "Não";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Sim";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "Não";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Sim";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "Não";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Sim";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "Não";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Sim";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "Não";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Sim";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "Não";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Sim";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "Não";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Sim";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "Não";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Sim";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "Não";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Sim";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Outros (Texto Livre)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "Não";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "Não";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Sim";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "Não";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "Não";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Sim";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "Não";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Sim";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "Não";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Sim";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "Não";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Sim";
translations[OPTION_WITHPUMPOPTIONS_NO] = "Não";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "Não";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Sim";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = " Não";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "Não";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Sim";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "Não";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Sim";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "Não";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Sim";
translations[OPTION_GELPACKSOPTIONS_NO] = "Não";
translations[OPTION_GELPACKSOPTIONS_YES] = "Sim";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "Não";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Sim";
translations[OPTION_ALARMOPTIONS_NO] = "Não";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "Não";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Sim";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "Não";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "Não";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Sim";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "Não";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Sim";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "Não";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Desconhecido";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "Não";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Sim";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Outros (Texto livre)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "Não";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Sim";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "Não";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Sim";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "Não";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Sim";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Perguntado/desconhecido";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Perguntado/desconhecido";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = " Não";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Nenhum dos itens acima.";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "Não - descreva a cor (texto livre)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Sim - Especifique a ferramenta usada (Texto livre)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Separação";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Nenhum";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Sim - Outro (texto livre)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "Não";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Quilograma (s)";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = " Libra (s)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = " Não";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Desconhecido";
translations[PLEASE_ENTER_THE_VALUE] = "Por favor, Inserir o valor";
translations[PLEASE_SELECT_THE_VALUE] = "Por favor, selecione o valor";
translations[PLEASE_SELECT_THE_DATE] = "Por favor, selecione a data";
translations[PLEASE_CHOOSE_THE_VALUE] = "Por favor, escolha o valor";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Desconhecido";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GRÃ BRETANHA";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "IRLANDA DO NORTE";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFEGANISTÃO";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ILHAS ALAND";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBÂNIA";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ARGÉLIA";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "SAMOA AMERICANA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTÁRTICA/ANTÁRTIDA";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTÍGUA E BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMÊNIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRÁLIA";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "ÁUSTRIA";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBAIJÃO";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHREIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BIELORRÚSSIA";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BÉLGICA";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIM";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDAS";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BUTÃO";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLÍVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BÓSNIA E HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "ILHA BOUVET";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRASIL";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "TERRITÓRIO BRITÂNICO DO OCEANO ÍNDICO ";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGÁRIA";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURQUINHA FASSO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMBOJA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "CAMARÕES";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADÁ";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "CABO VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "ILHAS CAIMÃ";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "REPÚBLICA CENTRO-AFRICANA";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CHADE";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINA";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "ILHA DO NATAL";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "ILHAS COCOS (KEELING)";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLÔMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMORES";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "REPÚBLICA DEMOCRÁTICO DO CONGO";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "ILHAS COOK";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "COSTA DO MARFIM ";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CROÁCIA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CHIPRE";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "REPÚBLICA CHECA";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DINAMARCA";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "REPÚBICA DO DJIBUT";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMÍNICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "REPÚBLICA DOMINICANA";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "EQUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGITO";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "GUINÉ EQUATORIAL";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREIA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTÔNIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETIÓPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "ILHAS MALVINAS (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "ILHAS FEROE";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLÂNDIA";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANÇA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "GUIANA FRANCESA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "POLINÉSIA FRANCESA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "TERRITÓRIOS FRANCÊS DO SUL ";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABÃO";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GÂMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEÓRGIA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "ALEMANHA";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GRÉCIA";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GROELÂNDIA ";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRANADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADALUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINÉ";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINÉ-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUIANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "ILHA HEARD E ILHAS MCDONALD";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "VATICANO";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONG KONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "HUNGRIA";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ISLÂNDIA";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "ÍNDIA";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONÉSIA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "REPÚBLICA ISLÂMICA DO IRÃ";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAQUE";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRLANDA";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ILHA DE MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITÁLIA";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPÃO";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDÂNIA";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "CAZAQUISTÃO";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "QUÊNIA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "CORÉIA DO NORTE ";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "CORÉIA DO SUL";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "QUIRGUISTÃO";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "REPÚBLICA DEMOCRÁTICA POPULAR DO LAOS";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LETÔNIA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LÍBANO";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBÉRIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LÍBIA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITUÂNIA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBURGO";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAU";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDÓNIA DO NORTE ";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGÁSCAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALÁSIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVAS";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "ILHAS MARSHALL";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINICA";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITÂNIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURÍCIA";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAIOTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MÉXICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "ESTADOS FEDERADOS DA MICRONÉSIA";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDÁVIA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MÔNACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGÓLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MARROCOS";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOÇAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMÍBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "HOLANDA";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NOVA CALEDÓNIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NOVA ZELÂNDIA";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARÁGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NÍGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGÉRIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "ILHA NORFOLK";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "ILHAS MARIANA DO NORTE";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORUEGA";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMÃ";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAQUISTÃO";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTINA";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMÁ";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA - NOVA GUINÉ";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAI";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "FILIPINAS";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLÔNIA";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGAL";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PORTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "CATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "REUNIÃO";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "ROMÊNIA";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "RÚSSIA";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RUANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SÃO BARTOLOMEU ";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SANTA HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SÃO CRISTÓVÃO NEVES";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SANTA LÚCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SÃO MARTINHO";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SÃO PEDRO E MIQUELÃO";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SÃO VICENTE E AS GRANADINAS";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SÃO MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SÃO TOMÉ E PRÍNCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "ARÁBIA SAUDITA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SÉRVIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEICHELES";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SERRA LEOA";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPURA";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "ESLOVÁQUIA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "ESLOVÊNIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "ILHAS SALOMÃO";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMÁLIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "ÁFRICA DO SUL";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "ILHAS GEÓRGIA DO SUL E SANDWICH DO SUL";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "ESPANHA";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDÃO";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAME";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD E JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "ESSUATÍNE";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SUÉCIA";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SUÍÇA";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SÍRIA";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TAJIQUISTÃO";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZÂNIA";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "TAILÂNDIA";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOQUELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD E TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNÍSIA";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "PERU";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURQUEMENISTÃO";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "ILHAS TURCAS E CAICOS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UCRÂNIA";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "EMIRADOS ÁRABES UNIDOS";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "REINO UNIDO";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "ESTADOS UNIDOS";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "ILHAS MENORES DISTANTES DOS ESTADOS UNIDOS";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAI";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEQUISTÃO";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIETNÃ";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "ILHAS VIRGENS BRITÂNICAS";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "ILHAS VIRGENS AMERICANAS";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS E FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "SAARA OCIDENTAL";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "IÉMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZÂMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBÁBUE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "Não";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Desconhecido";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Sim";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Eu li e compreendi o Aviso de Privacidade vinculado ao Portal de Feedback de Produtos da Vantive.";
translations[PRODUCT_LOT] = "Lote de Produto";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Etiqueta de envio/distribuição";
translations[CARTON_LABEL] = "Etiqueta de cartão";
translations[INTERNAL_PRODUCT_LABEL] = "Etiqueta interna do produto";
translations[TITLE_PD_RENAL] = "DP renal";
translations[TITLE_SOLUTIONS] = "Soluções";
translations[TITLE_ACCESS] = "Acesso";
translations[TITLE_ALL_OTHER_PRODUCT] = "Todos os outros produtos";
translations[REPORTED_PROBLEM] = "Problema relatado";
translations[LOGIN] = "Conecte-se";
translations[SYSTEM_MENU] = "Menu do sistema";
translations[INITIATE_PRODUCT_FEEDBACK] = "Iniciar o retorno do produto ";
translations[FEEDBACK_STATUS] = "Status do feedback";
translations[OKTACALLBACK] = "OktaCallback";
translations[VALID_EMAIL] = "Inserir um endereço de e-mail válido";
translations[VALID_NUMERIC] = "Insira o número";
translations[PLEASE_UPLOAD_IMAGE] = "Faça o upload da imagem (s)";
translations[VALID_DATE] = "Por favor selecione uma data válida";
translations[QUANTITY] = "Quantidade";
translations[EDIT] = "Editar";
translations[DELETE] = "Excluir";
translations[LOT_SERIAL_NO] = "Nº de lote/série";
translations[LOT_NUMBER_NOT_FOUND] = "Número do lote não encontrado";
translations[SEARCHING_LOT_NUMBER] = "Pesquisando o número do lote";
translations[PRODUCT_CODE_NOT_FOUND] = "Código do produto não encontrado";
translations[SEARCHING_PRODUCT_CODE] = "Pesquisando o código do produto";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Arquivos de tipos (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps) não são permitidos";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "O arquivo que você está tentando anexar excede o limite de armazenamento. Por favor, comprima ou anexe um arquivo diferente.";
translations[IMAGE_ICON] = "Clique no ícone da imagem para selecionar a opção";
translations[LOGIN_TO_ACCOUNT] = "Entrar na conta";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Faça login em sua conta";
translations[PASSWORD] = "Senha";
translations[SIGN_IN] = "Entrar";
translations[UNKNOWN] = "Desconhecido";
translations[ASKED_UNKNOWN] = "Perguntado/desconhecido";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Selecione o país";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Chinês (Chinês Simplificado)";
translations[DUTCH] = "Holandês";
translations[ENGLISH] = "Inglês";
translations[FRENCH] = "Francês";
translations[GERMAN] = "Alemão";
translations[ITALIAN] = "Italiano";
translations[JAPANESE] = "Japonês";
translations[KOREAN] = "Coreano";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarim (Chinês Tradicional)";
translations[POLISH] = "Polonês";
translations[PORTUGUESE] = "Português";
translations[SPANISH] = "Espanhol";
translations[THAI] = "Tailandês";
translations[TURKISH] = "Turco";
translations[VIETNAMESE] = "Vietnamita";
translations[BROWSE] = "Navegar";
translations[FEEDBACK_SUBMITTED] = "Comentários enviados";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "O retorno da experiência do produto foi enviado com sucesso. Obrigado por seu relato. Você receberá um e-mail contendo um número de referência. Como fornecedor de produtos médicos, a satisfação do cliente e o retorno com o nosso produto são essenciais para o nosso objetivo de fornecer produtos da mais alta qualidade. Por favor entre em contato";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "se você tiver dúvidas ou informações adicionais.";
translations[CLOSE] = "Perto";
translations[PATIENT_AGE] = "Idade do paciente";
translations[ENTER_AGE] = "Insira a idade";
translations[PATIENT_DOB] = "Data de nascimento do paciente";
translations[RELEVANT_ATTACHMENTS] = "Forneça quaisquer anexos relevantes";
translations[VANTIVE_ACCOUNT_CREDENTIALS] = "Inserir suas credenciais da Conta Vantive";
translations[GET_PRODUCT_DETAILS] = "Obter detalhes do produto";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Use o diagrama acima (figura 2) para determinar a localização do problema relatado";
translations[FACILITY_ADDRESS] = "Endereço da empresa";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Outro endereço de empresa";
translations[CHOOSE_PRODUCT_CODE] = "Por favor, escolha o Código do Produto para o Lote/Número de Série inserido";
translations[DECLINE] = "Recusar";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT ESTATIUS E SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURAÇAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "SUDÃO DO SUL";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "indica que o texto de ajuda está disponível para este campo";
translations[YOUR_FIRST_NAME] = "O seu Nome";
translations[YOUR_LAST_NAME] = "O seu Sobrenome";
translations[MY_FIRST_NAME] = "O meu Nome";
translations[MY_LAST_NAME] = "O meu Sobrenome";
translations[PATIENT_FIRST_NAME] = "Nome do Doente";
translations[PATIENT_LAST_NAME] = "Sobrenome do Doente";
translations[REPORTER_FIRST_NAME] = "Nome do Notificador";
translations[REPORTER_LAST_NAME] = "Sobrenome do Notificador";
translations[EMPLOYEE_FIRST_NAME] = "Nome do funcionário";
translations[EMPLOYEE_LAST_NAME] = "Sobrenome do funcionário";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Nome do utilizador final/cliente";
translations[END_USER_CUSTOMER_LAST_NAME] = "Sobrenome do utilizador final/cliente";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Nome do Contacto Adicional";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Sobrenome do Contacto Adicional";
translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_VANTIVE] = "Vantive";
translations[COPYRIGHT_VERSION] = "Todos os direitos reservados | Versão";
translations[ADD_ADDITIONAL_CONTACT] = "Adicionar contacto adicional";
translations[CONTACT_ME] = "O cliente não deseja ser contactado. Entre em contacto comigo para quaisquer perguntas adicionais.";
translations[DO_NOT_CONTACT] = "Não entre em contacto";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Nome da empresa/instalações do utilizador final/cliente";
translations[END_USER_CUSTOMER_PHONE] = "Número de telefone do utilizador final/cliente";
translations[END_USER_CUSTOMER_EMAIL] = "E-mail do utilizador final/cliente";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Morada do utilizador final/cliente";
translations[SAME_AS_PATIENT_ADDRESS] = "Igual ao endereço do paciente";
translations[SAME_AS_REPORTER_ADDRESS] = "Igual ao endereço do notificador";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Igual ao morada do utilizador final/cliente";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Use o diagrama acima (figura 3) para determinar a localização do problema relatado";
translations[CONTACT_US] = "Contate-nos";
translations[LANDING_BRIEF_FOR_DEVICE] = "Para reparos, peças, serviços ou suporte técnico do dispositivo, entre em contato com a equipe de suporte técnico local.";
translations[PATIENT_SEX] = "Sexo do paciente";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Homem/menino cisgênero";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Mulher/menina cisgênero";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Homem trans/homem trans/mulher para homem";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Mulher transexual/mulher trans/homem para mulher";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Outra categoria de gênero; por favor especifique";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Recusar-se a responder";
translations[ATTENTION_NEEDED] = "!!! ATENÇÃO URGENTE NECESSÁRIA: O envio do Portal de Feedback de Produtos FALHOU!";
translations[SUBMIT_ERR_MSG] = "Para reenviar, clique em OK e, em Enviar ou, envie sua reclamação por e-mail para (@@@).";
translations[SUBMIT_RETRY_MSG] = "Se você reenviou, verifique se recebeu um e-mail de confirmação em sua caixa de e-mail do Portal de Feedback do Produto. Se nenhum e-mail de confirmação foi recebido, o envio não foi bem-sucedido e você DEVE enviar sua reclamação por e-mail para (@@@).";
translations[OK] = "OK";

export default lang;